// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"j_s","noSpacing":"j_t"};